module.exports = __webpack_public_path__ + "static/img/11.8e0f28aa.jpg";